import { execOnLoad, getA11yTranslations, getCssVariable } from '@general/helpers';
import throttle from 'lodash/throttle';
import Swiper from 'swiper';
import { A11y, Navigation, Scrollbar } from 'swiper/modules';

if (!window.dAgency) window.dAgency = {};
window.dAgency.initCarousel = (context, destroy = false) => {
  const snippetContainer = context.classList.contains('carousel__container')
    ? context
    : context.closest('.carousel__container');
  if (!snippetContainer) return;

  if (destroy) {
    if (snippetContainer.handleSwiper) {
      if (typeof snippetContainer.handleSwiper.cancel === 'function') {
        snippetContainer.handleSwiper.cancel();
      }
      window.removeEventListener('resize', snippetContainer.handleSwiper);
      snippetContainer.handleSwiper = null;
    }
    if (snippetContainer.swiper) {
      snippetContainer.swiper.destroy(true, true);
      snippetContainer.swiper = null;
    }
    snippetContainer.isCarouselDisabled = true;
    return;
  }

  const sliderWrapper = snippetContainer.querySelector('.carousel__slider-wrapper');
  const slides = snippetContainer.querySelectorAll('.swiper-slide');
  if (!sliderWrapper || slides.length <= 1) {
    // If it was previously a carousel, we should probably destroy it
    if (snippetContainer.swiper) {
      snippetContainer.swiper.destroy(true, true);
      snippetContainer.swiper = null;
    }
    return;
  }

  snippetContainer.isCarouselDisabled = false;

  const leftArrow = snippetContainer.querySelector('.carousel__arrow--left');
  const rightArrow = snippetContainer.querySelector('.carousel__arrow--right');
  const scrollbar = snippetContainer.querySelector('.carousel__scrollbar');
  const options = {
    modules: [
      ...(window.dAgency.translations ? [A11y] : []),
      ...(leftArrow && rightArrow ? [Navigation] : []),
      ...(scrollbar ? [Scrollbar] : []),
    ],
    ...(scrollbar ? { scrollbar: { el: scrollbar, draggable: true } } : {}),
    ...(leftArrow && rightArrow ? { navigation: { prevEl: leftArrow, nextEl: rightArrow } } : {}),
    ...getA11yTranslations(),
  };

  if (snippetContainer.handleSwiper) {
    if (typeof snippetContainer.handleSwiper.cancel === 'function') {
      snippetContainer.handleSwiper.cancel();
    }
    window.removeEventListener('resize', snippetContainer.handleSwiper);
  }

  snippetContainer.handleSwiper = throttle(() => {
    if (snippetContainer.isCarouselDisabled) return;

    if (snippetContainer.swiper) {
      snippetContainer.swiper.destroy(true, true);
    }
    snippetContainer.swiper = new Swiper(sliderWrapper, {
      ...options,
      slidesPerView: getCssVariable(snippetContainer, '--slides'),
      spaceBetween: getCssVariable(snippetContainer, '--gap'),
    });
  }, 300);

  snippetContainer.handleSwiper();
  window.addEventListener('resize', snippetContainer.handleSwiper);
};

execOnLoad((context) => {
  const isManaged = context.hasAttribute('data-managed') || context.closest('.product-upsells__section');
  if (!isManaged) {
    window.dAgency.initCarousel(context);
  }
}, '.carousel__container');
